import axios from "axios";
import { API_ENDPOINT } from "../../common/constants/apiConstants";


export const getDashboardMetrics = async() => {
    const url = `${API_ENDPOINT.GET_DASHBOARD.METRICS}?timestamp=${Date.now()}`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Dashboard Metrics Failed:", error);
      throw error.response?.data || { message: "Network error" };
    }
  };


export const getRecentInterviews = async(page = 1, limit = 10) => {
  const url = API_ENDPOINT.GET_DASHBOARD.RECENT_INTERVIEWS;
  try {
    const response = await axios.get(url, {
      params: {
        page,
        limit,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Network error" };
  }
};

